import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';

export default class ClassGroupResultsTeamsCardComponent extends Component 
{
	@service store;
	@service() config
	
	@tracked classGroup = null;
	
	@action
	refresh()
	{
		if (this.args.onRefresh) 
		{
			this.args.onRefresh();
		}
	};
	
	@action
	selectClassGroup(event)
	{
		var classGroupId = event.target.value;
		
		if(classGroupId == '-')
		{
			this.classGroup = null;
		}
		else
		{
			var that = this;
			this.store.findRecord('classGroup', classGroupId).then(function(foundClassGroup)
			{
				that.classGroup = foundClassGroup;
			});
		}
	};
	
	@computed('config')
	get host() 
	{
		return this.config.get('resultsBackendProtocol')+"://"+this.config.get('resultsBackendHost')+":"+this.config.get('resultsBackendPort');
	}
	
	@computed('config')
	get namespace() 
	{
		return this.config.get('resultsBackendNamespace');
	}
	
	get classGroupResultsDisabled()
	{
		return this.classGroup == null ? "disabled" : "";
	};
	
	get resultsCSVLink()
	{
		if(!this.classGroup)
			return "";
		return this.host+this.namespace+"/events/"+this.args.event.id+"/results/classGroup/"+this.classGroup.id+"/teams?format=csv";
	};
};